import { createFileRoute, Link } from '@tanstack/react-router'
import { installations, useInstallation } from '@/installation/api'
import AssetHealthPage from '@/views/refrigerant/customer/asset-health-page'
import { ThaloWebContextProvider } from '@/contexts/ThaloWebContext'
import { usePosthogGroup } from '@/posthog/usePosthogGroup'

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/health',
)({
  params: {
    parse: (rawParams) => ({ assetId: parseInt(rawParams.assetId) }),
  },
  loader: ({ context: { queryClient }, params: { assetId } }) =>
    queryClient.ensureQueryData(installations.detail(assetId)),
  component: RouteComponent,
  staticData: {
    breadcrumb: Breadcrumb,
  },
})

function RouteComponent() {
  const { assetId } = Route.useParams()
  const { data: asset } = useInstallation(assetId)

  usePosthogGroup('asset', asset)

  return (
    <ThaloWebContextProvider>
      <AssetHealthPage />
    </ThaloWebContextProvider>
  )
}

function Breadcrumb() {
  const { assetId } = Route.useParams()
  const { data: asset } = useInstallation(assetId)
  return (
    <Link to={Route.fullPath} params={Route.useParams()}>
      {`${asset.sublocation} - ${asset.name} - Health`}
    </Link>
  )
}
